import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';

/** M13 · Configurações. Abas no menu Admin, depois das do Painel admin (ordem 7 a 12). */
const carregar0 = () => import('./Empresa');
const carregar1 = () => import('./Aparencia');
const carregar2 = () => import('./Sequencias');
const carregar3 = () => import('./Campos');
const carregar4 = () => import('./Visoes');
const carregar5 = () => import('./Modelos');
const carregar6 = () => import('./util');

const Empresa = telaSobDemanda(carregar0, 'Empresa');
const Aparencia = telaSobDemanda(carregar1, 'Aparencia');
const Sequencias = telaSobDemanda(carregar2, 'Sequencias');
const Campos = telaSobDemanda(carregar3, 'Campos');
const Visoes = telaSobDemanda(carregar4, 'Visoes');
const Modelos = telaSobDemanda(carregar5, 'Modelos');
const AcaoNovo = acaoSobDemanda(carregar6, 'AcaoNovo');

export const modulo: ModuloWeb = {
  slug: 'configuracoes',
  menu: 'admin',
  dicionario,
  abas: [
    { rotulo: 'abas.empresa', caminho: 'empresa', elemento: <Empresa />, Acao: () => <AcaoNovo rotulo="acoes.novaEmpresa" />, ordem: 7 },
    { rotulo: 'abas.aparencia', caminho: 'aparencia', elemento: <Aparencia />, ordem: 8 },
    { rotulo: 'abas.sequencias', caminho: 'sequencias', elemento: <Sequencias />, Acao: () => <AcaoNovo rotulo="acoes.novaSequencia" />, ordem: 9 },
    { rotulo: 'abas.campos', caminho: 'campos-personalizados', elemento: <Campos />, Acao: () => <AcaoNovo rotulo="acoes.novoCampo" />, ordem: 10 },
    { rotulo: 'abas.visoes', caminho: 'visoes-salvas', elemento: <Visoes />, ordem: 11 },
    { rotulo: 'abas.modelos', caminho: 'modelos', elemento: <Modelos />, Acao: () => <AcaoNovo rotulo="acoes.novoModelo" permissao="configuracoes.criar" />, ordem: 12 },
  ],
};
